import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../components/select/main/Select";
import { useLanguageContext } from "../../../context/LanguageContext";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import { StyledFlexColumn } from "../../../styles/LayoutStyles";

function MessagebirdConfigsPageView({
  messagebirdConfigData,
  onApiKeyChange,
  onOriginatorChange,
  onActiveChange,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <OverlayLoader groups="messagebird_configs_page_fetch">
      <FormContainer
        onSubmit={onSubmit}
        submitError={submitError}
        submitLoadingGroup={"messagebird_configs_page_save"}
      >
        <StyledFlexColumn>
          <InputWrapper
            label={translate("eva.main.validation.attributes.active")}
            required
            error={EVAApiHelper.getResponseError("active", submitError)}
          >
            <Select
              options={[
                { value: true, label: translate("eva.main.general.yes") },
                { value: false, label: translate("eva.main.general.no") },
              ]}
              value={messagebirdConfigData.active}
              onChange={onActiveChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.api_key")}
            required
            error={EVAApiHelper.getResponseError("api_key", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate("eva.main.validation.attributes.api_key")}
              value={messagebirdConfigData.api_key}
              onChange={onApiKeyChange}
            />
          </InputWrapper>

          <InputWrapper
            label={translate("eva.main.validation.attributes.originator")}
            required
            error={EVAApiHelper.getResponseError("originator", submitError)}
          >
            <StyledInput
              type="text"
              placeholder={translate(
                "eva.main.validation.attributes.originator",
              )}
              maxLength={11}
              value={messagebirdConfigData.originator}
              onChange={onOriginatorChange}
            />
          </InputWrapper>
        </StyledFlexColumn>
      </FormContainer>
    </OverlayLoader>
  );
}

export default MessagebirdConfigsPageView;
